export var KeyboardKey;
(function (KeyboardKey) {
    KeyboardKey["Enter"] = "Enter";
    KeyboardKey["Space"] = " ";
    KeyboardKey["Left"] = "ArrowLeft";
    KeyboardKey["Up"] = "ArrowUp";
    KeyboardKey["Right"] = "ArrowRight";
    KeyboardKey["Down"] = "ArrowDown";
})(KeyboardKey || (KeyboardKey = {}));
//# sourceMappingURL=index.js.map